module.exports = __webpack_public_path__ + "img/T6-D-rc_5.35cc469e.png";